import React, { Component } from 'react';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import './FilterRowStyles.scss';

class FilterRow extends Component {
  render() {
    const {
      className,
      children,
    } = this.props;
    return (
      <div className={classNames('filter-row', className)}>
        <div className="filter-list">
          {children}
        </div>
      </div>
    );
  }
}

export default compose(
  injectIntl,
)(FilterRow);
